/** Any origin works as the base: only whether the address stays on it matters. */
const PROBE_ORIGIN = 'https://serviceledger.invalid';

/**
 * The `redirect` of `/login` and `/login/tenant`: the page a guard sent the person away from, to
 * return to it once inside. Only an address of this same console is accepted, a path that starts
 * with `/` but not with `//` (another host, to the browser); the URL parser settles the tricks a
 * plain prefix test misses, like `/\otro.example` or a tab between the two slashes. Anything else
 * is dropped, and the person lands on the home page as if no `redirect` had come.
 */
export function internalRedirect(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return undefined;
  }

  try {
    return new URL(value, PROBE_ORIGIN).origin === PROBE_ORIGIN ? value : undefined;
  } catch {
    return undefined;
  }
}

/** `validateSearch` of `/login` and `/login/tenant`. */
export interface RedirectSearch {
  redirect?: string;
}

export function redirectSearchSchema(search: Record<string, unknown>): RedirectSearch {
  const redirect = internalRedirect(search['redirect']);
  return redirect === undefined ? {} : { redirect };
}
